/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputUavMissionFlightParams
 */
export interface InputUavMissionFlightParams {
    /**
     * Altitude — текст, бо в заявках трапляються діапазони («200-2000»), а не лише одне число.
     * @type {string}
     * @memberof InputUavMissionFlightParams
     */
    altitude?: string;
    /**
     * SpeedKmh — км/год (перерахунок з м/с робить клієнт/парсер, у сервіс приходять км/год).
     * @type {number}
     * @memberof InputUavMissionFlightParams
     */
    speedKmh?: number;
}

/**
 * Check if a given object implements the InputUavMissionFlightParams interface.
 */
export function instanceOfInputUavMissionFlightParams(value: object): boolean {
    return true;
}

export function InputUavMissionFlightParamsFromJSON(json: any): InputUavMissionFlightParams {
    return InputUavMissionFlightParamsFromJSONTyped(json, false);
}

export function InputUavMissionFlightParamsFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputUavMissionFlightParams {
    if (json == null) {
        return json;
    }
    return {
        
        'altitude': json['altitude'] == null ? undefined : json['altitude'],
        'speedKmh': json['speedKmh'] == null ? undefined : json['speedKmh'],
    };
}

export function InputUavMissionFlightParamsToJSON(value?: InputUavMissionFlightParams | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'altitude': value['altitude'],
        'speedKmh': value['speedKmh'],
    };
}

